import { pathAssets } from '@/globals/globalvariables'
import type { LoaderDataTypes } from '@powerplay/core-minigames'
import { ModelsNames } from '../types'

// Hlavny priecinok s modelmi
const modelsDir = `${pathAssets}/models/`

/**
 * Konfig pre modely
 */
export const modelsConfig: LoaderDataTypes = {
  [ModelsNames.skier]: {
    version: 2402063,
    ext: 'glb',
    genderActive: true,
    femaleVersion: 240307,
    dir: modelsDir,
    mainMeshNames: [ModelsNames.skier],
    ignoreInModes: [9, 10]
  },
  [ModelsNames.hill]: {
    ext: 'glb',
    version: 12,
    dir: modelsDir
  },
  [ModelsNames.rifle]: {
    version: 9,
    ext: 'glb',
    dir: modelsDir,
    mainMeshNames: [ModelsNames.rifle]
  }
}
